import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { mapTo, switchMap } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { EnvironmentConfigService } from '@stylehaven/components';
@Injectable({ providedIn: 'root' })
export class CacheClearService {
    private readonly clearCacheEndpoint: string = `auth/clear-cache.php`;

    private readonly baseUrl$: Observable<string>;

    constructor(
        private readonly configService: EnvironmentConfigService,
        private httpClient: HttpClient
    ) {
        this.baseUrl$ = this.configService.get('authorizationUrl');
    }

    public clearCache(): Observable<boolean> {
        return this.baseUrl$.pipe(
            switchMap(baseUrl =>
                this.httpClient.get(`${baseUrl}${this.clearCacheEndpoint}`, { responseType: 'text' }).pipe(mapTo(true))
            )
        );
    }
}
